<template>
  <v-card class="mx-auto" max-width="300">
    <!-- this.uiStore.toggleWorkspaceSidebar(); -->
    <v-list>
      <v-card>
        <v-sheet>
          <v-card-item>
            <v-card-title>Usuario  <v-btn
                icon="mdi-menu-close"
                size="small"
                variant="text"
                @click="closeMenu"
              ></v-btn></v-card-title>
            <template v-slot:append>
             
            </template>
              <v-label class="w-full mt-0 px-2 py-1 bg-slate-600/15 shadow-sm text-xs" >{{ "v" + version }}</v-label> 
              <v-label class="w-full mt-2 px-2 py-1 bg-slate-600/15 shadow-sm" @click="goLogout" >Logout</v-label> 
              <v-label class="w-full mt-2 px-2 py-1 bg-slate-600/15 shadow-sm" @click="openPasswordModal" >Cambiar contraseña</v-label> 
              
      
            <!-- Modal para cambiar contraseña -->
            <v-dialog v-model="showPasswordModal" persistent max-width="400px">
              <v-card>
                <v-card-title class="headline">Cambiar contraseña</v-card-title>
                <v-card-text>
                  <v-form ref="passwordForm" @submit.prevent="submitPasswordChange">
                      <v-text-field
                      v-model="currentPassword"
                      :type="showPassword ? 'text' : 'password'"
                      label="Contraseña actual"
                      :rules="[rules.required, rules.min]"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPassword"
                      :type="showPassword ? 'text' : 'password'"
                      label="Nueva contraseña"
                      :rules="[rules.required, rules.min]"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                    <v-text-field
                      v-model="repeatPassword"
                      :type="showPassword ? 'text' : 'password'"
                      label="Repetir contraseña"
                      :rules="[rules.required, rules.match]"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </v-form>
                  <div v-if="passwordError" class="red--text text-caption mt-2">{{ passwordError }}</div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="submitPasswordChange">Guardar</v-btn>
                  <v-btn color="grey" @click="closePasswordModal">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-item>
          <v-card-item>
            <v-card-title>Opciones</v-card-title>
            <!-- <template v-slot:append>
              <v-btn
                icon="mdi-menu-close"
                size="small"
                variant="text"
                @click="closeMenu"
              ></v-btn>
            </template> -->
          </v-card-item>
          <v-card-item v-if="activeSound !== null && activeSound !== undefined">
            <v-switch
              color="primary"
              label="Pausa Automatica"
              v-model="activeAutoPause"
            ></v-switch>
            <v-switch color="primary" label="Sonido" v-model="activeSound"></v-switch>
            <v-switch
              color="primary"
              label="Iconos de detección"
              v-model="showFrame"
            ></v-switch>
          </v-card-item>

          <v-card-item v-if="this.showHMS == false">
            <v-card-title class="text-lime-400">Sin Alertas Dock</v-card-title>
          </v-card-item>
          <v-card v-else color="success">
            <v-sheet>
              <v-card-item>
                <v-card-title>Alertas Dock</v-card-title>
              </v-card-item>
              <v-card-item v-for="(item, index) in hms.data" :key="item.id">
                <TSAFormatHms :item="item" :index="index"></TSAFormatHms>
              </v-card-item>
            </v-sheet>
          </v-card>
        </v-sheet>
      </v-card>
    </v-list>

    <!--
        <v-list>
            <v-card>
                <v-sheet>
                    <v-card-item>
                        <v-card-title>Acciones</v-card-title>
                        <template v-slot:append>
                            <v-btn icon="$close" size="small" variant="text" @click="removeActions"></v-btn>
                        </template>
                    </v-card-item>

                </v-sheet>
            </v-card>



            <v-list-item-group>
                <v-list-item v-for="(service, index) in services" :key="service.id">
                    <TSAFormatItem :item="service" :index="index"></TSAFormatItem>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        -->
  </v-card>
</template>

<script>
//import TSAFormatItem from './TSAFormatItem.vue';
import TSAFormatHms from "./TSAFormatHms.vue";
import useUiStore from "@/ui";
import uiStore2 from "@/store/ui";
import { ref } from "vue";
import { getDeviceSettings, setDeviceSettingKey } from "@/services/backendService.js";
import { storeToRefs } from "pinia";
import { notify } from "notiwind";
import useStore from '@/store';
import { changePassword } from '@/services/changePassword.js'; // Asegúrate de que la ruta es correcta
export default {
  name: "TSAMenuBar",
  components: {
    //TSAFormatItem,
    TSAFormatHms,
  },
  setup() {
    const uiStore = useUiStore();
    const { hms, services, notifications } = storeToRefs(uiStore2());
    const { version } = storeToRefs(useStore());
    const showFrame = ref(false);
    return {
      uiStore,
      hms,
      services,
      notifications,
      showFrame,
      version,
    };
  },
  data() {
    return {
      activeAutoPause: null,
      activeSound: null,
      text: "",
      tid: null,
      showPasswordModal: false,
      currentPassword: '',
      newPassword: '',
      repeatPassword: '',
      showPassword: false,
      passwordError: '',
      rules: {
        required: v => !!v || 'Campo requerido',
        min: v => (v && v.length >= 6) || 'Mínimo 6 caracteres',
        match: v => v === this.newPassword || 'Las contraseñas no coinciden',
      },
    };
  },
  computed: {
    showHMS() {
      if (Object.prototype.hasOwnProperty.call(this.hms, "data")) {
        return this.hms.data.length > 0;
      } else {
        return false;
      }
    },
  },
  methods: {
    changePassword,
    openPasswordModal() {
      this.showPasswordModal = true;
      this.currentPassword = '';
      this.newPassword = '';
      this.repeatPassword = '';
      this.passwordError = '';
    },
    closePasswordModal() {
      this.showPasswordModal = false;
    },
    async submitPasswordChange() {
      // Validación básica
      if (!this.newPassword || !this.repeatPassword) {
        this.passwordError = 'Debes completar ambos campos.';
        return;
      }
      if (this.newPassword.length < 6) {
        this.passwordError = 'La contraseña debe tener al menos 6 caracteres.';
        return;
      }
      if (this.newPassword !== this.repeatPassword) {
        this.passwordError = 'Las contraseñas no coinciden.';
        return;
      }
      this.passwordError = '';
      // Esqueleto para llamada a API
      // Aquí deberías llamar a la API para cambiar la contraseña
      // Ejemplo:
      // await changePasswordApi(this.newPassword)
      const result = await this.changePassword(this.currentPassword, this.newPassword);
      if (result) {
        this.passwordError = '';
        notify(
            {
              group: 'default',
              level: 'info',
              title: 'Contraseña Cambiada',
              text: 'Contraseña cambiada exitosamente',
            },
            5000 // 5s
          )
        this.closePasswordModal();
        this.$router.push("/");
      } else {
        this.passwordError = 'Error al cambiar la contraseña. Inténtalo de nuevo.';
        return;
      }
      
      // Opcional: mostrar notificación de éxito
    },
    goLogout() {
      this.$router.push("/");
    },
    async getAutoPause() {
      try {
        const data = await getDeviceSettings();
        this.activeAutoPause = data["auto_stop"] === true;
      } catch {
        console.log("error getting auto pause status");
      }
    },
    async setAutoPause(value) {
      try {
        await setDeviceSettingKey("auto_stop", value);
        await this.getAutoPause();
      } catch {
        console.log("error");
      }
    },
    getSound() {
      if (
        localStorage.getItem("sound") === undefined ||
        localStorage.getItem("sound") === null
      ) {
        localStorage.setItem("sound", true);
      }
      const value = localStorage.getItem("sound");
      this.activeSound = value === "true" || value === true;
    },
    getShowFrame() {
      if (
        localStorage.getItem("showFrame") === undefined ||
        localStorage.getItem("showFrame") === null
      ) {
        localStorage.setItem("showFrame", false);
      }
      this.showFrame =
        localStorage.getItem("showFrame") === "true" ||
        localStorage.getItem("showFrame") === true;
    },
    setInt() {
      self.tid = setInterval(async () => {
        await this.getAutoPause();
      }, 5000);
    },
    removeActions() {
      this.services = [];
    },
    closeMenu() {
      this.uiStore.toggleWorkspaceSidebar();
    },
    //
  },
  watch: {
    activeSound(value) {
      localStorage.setItem("sound", value);
    },
    activeAutoPause(value, oldValue) {
      if (value !== oldValue && oldValue !== null && oldValue !== undefined) {
        this.setAutoPause(value);
      }
    },
    showFrame(value) {
      console.log("Update show frame", value);
      localStorage.setItem("showFrame", value);
    },
  },

  async mounted() {
    await this.getAutoPause();
    this.getSound();
    this.setInt();
    this.getShowFrame();
  },
  beforeUnmount() {
    clearInterval(this.tid);
  },
};
</script>

<style scoped></style>
